import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import {
  LucideAngularModule,
  FacebookIcon,
  InstagramIcon,
  TwitterIcon,
  YoutubeIcon,
  MessageCircleIcon,
  PhoneIcon,
  MailIcon,
  MapPinIcon,
} from 'lucide-angular';

@Component({
  selector: 'allas-desktop-footer',

  imports: [CommonModule, LucideAngularModule],
  templateUrl: 'desktop-footer.html',
})
export class DesktopFooterComponent {
  @Input() customerService: any[] = [];
  @Input() company: any[] = [];
  @Input() services: any[] = [];
  @Input() cities: any[] = [];
  @Input() shopping: any[] = [];
  @Input() categories: any[] = [];

  readonly facebookIcon = FacebookIcon;
  readonly instagramIcon = InstagramIcon;
  readonly twitterIcon = TwitterIcon;
  readonly youtubeIcon = YoutubeIcon;
  readonly messageCircleIcon = MessageCircleIcon;
  readonly phoneIcon = PhoneIcon;
  readonly mailIcon = MailIcon;
  readonly mapPinIcon = MapPinIcon;
}
